/**
 *  firebase/index.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

var firebase = require("firebase");

var production_BMS = {
  apiKey: "AIzaSyBrFBieHr2wt5hC3OEMR1mwXShLI-5lYiE",
  authDomain: "brasil-mais-seguro.firebaseapp.com",
  databaseURL: "https://brasil-mais-seguro.firebaseio.com",
  projectId: "brasil-mais-seguro",
  storageBucket: "brasil-mais-seguro.appspot.com",
  messagingSenderId: "828930457042",
  appId: "1:828930457042:web:34394bbd930929a5881c0b",
  measurementId: "G-DFT9JBY0VJ",
};

var production_ADG = {
  apiKey: "AIzaSyCc_013wXyZPrx0r2dW4kPl6NDcZGDnPAQ",
  authDomain: "soul-care-76ac5.firebaseapp.com",
  databaseURL: "https://soul-care-76ac5-default-rtdb.firebaseio.com",
  projectId: "soul-care-76ac5",
  storageBucket: "soul-care-76ac5.appspot.com",
  messagingSenderId: "460135926400",
  appId: "1:460135926400:web:15faf4fdc7c3ea87ecf465",
  measurementId: "G-H2RDN9E8DR",
};

firebase.initializeApp(production_BMS);

module.exports = {
  auth: firebase.auth(),
  database: firebase.database(),
  storage: firebase.storage(),
};



// WEBPACK FOOTER //
// ./src/firebase/index.js